module.exports = __webpack_public_path__ + "img/bsidd-3.2141dd3e.webp";